import { render } from "./_ProfileId.vue?vue&type=template&id=50a7e836"
import script from "./_ProfileId.vue?vue&type=script&lang=js"
export * from "./_ProfileId.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/forlove.elena-dating.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__